import { enumOutputFileFormat } from '@ingenico/api-sdk-device-management-private-v2';
import type { EnumOutputFileFormatApi } from '@ingenico/api-sdk-device-management-private-v2';
import { isEmpty, toString } from 'lodash-es';
import { MAX_DEVICE_OPTIONS } from './ParameterOutputFileModal.constants';
import type {
  IndexedParameterOutputFileDevice,
  ParameterOutputFileDevice,
  ParameterOutputFileModalModel,
} from './ParameterOutputFileModal.model';

export function findTemplateById(
  templates: ParameterOutputFileModalModel[],
  id: string,
): ParameterOutputFileModalModel | undefined {
  return templates.find(({ templateId }) => templateId === id);
}

export function getVisibleDevices(
  devices: ParameterOutputFileDevice[],
  search: string,
  selectedDeviceIndex: number,
): IndexedParameterOutputFileDevice[] {
  const indexedDevices = devices.map((device, index) => ({ device, index }));
  const searchedTerm = search.trim().toLowerCase();
  const matchingDevices = isEmpty(searchedTerm)
    ? indexedDevices
    : indexedDevices.filter(({ device }) =>
        toString(device.logicalDeviceName ?? device.logicalDeviceId)
          .toLowerCase()
          .includes(searchedTerm),
      );

  const shownDevices = matchingDevices.slice(0, MAX_DEVICE_OPTIONS);
  if (shownDevices.some(({ index }) => index === selectedDeviceIndex)) {
    return shownDevices;
  }

  const selectedDevice = indexedDevices[selectedDeviceIndex];
  return selectedDevice ? [selectedDevice, ...shownDevices] : shownDevices;
}

export function formatOutputFileCode(fileFormat: EnumOutputFileFormatApi | undefined, content: string): string {
  if (toString(fileFormat) !== enumOutputFileFormat.JSON) {
    return content;
  }

  try {
    return JSON.stringify(JSON.parse(content), null, 2);
  } catch {
    return content;
  }
}
